import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Radio,
  Table,
  CascaderSelect,
} from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import 'antd/dist/antd.css';

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const parameter = [
  {
    managementMoney: 3000,
  },
];

const PerMonthPoints = (props) => {
  // console.log(props)
  const {
    residentAccountNumbersArr,
    perMonthPointsResult,
    setPerMonthPointsResult,
    setInsertPointsDialog,
  } = props;

  const [managementMoney, setManagementMoney] = useState(null);

  const managementMoneyTotal = parameter[0].managementMoney;
  const pingsNumberTotal = residentAccountNumbersArr[0].pingsNumber;

  const pointsTotalResult = Math.ceil(
    managementMoneyTotal * pingsNumberTotal * 0.01
  );
  // console.log(pointsTotalResult)

  return (
    <>
      <Form {...formItemLayout}>
        <h2>每月點數計算</h2>
        <Form.Item label="管理費:">
          <h2>{parameter[0].managementMoney} 元</h2>
        </Form.Item>
        <Form.Item label="坪數:">
          <h2>
            {`${residentAccountNumbersArr[0].pingsNumber} 坪`
              ? `${residentAccountNumbersArr[0].pingsNumber} 坪`
              : '未設定坪數'}
          </h2>
        </Form.Item>
        <hr />
        <Form.Item label="合計點數:" help="每月管理費*坪數*0.01=合計點數">
          <h2>{pointsTotalResult} 點</h2>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 20 }}>
          <Form.Submit
            type="primary"
            onClick={() => {
              setPerMonthPointsResult(pointsTotalResult);
              setInsertPointsDialog(false);
            }}
            style={{ marginRight: 10 }}
          >
            確定
          </Form.Submit>
          {/* <Form.Reset onClick={() => {

          }}>清除</Form.Reset> */}
        </Form.Item>
      </Form>
      {/* <Table dataSource={residentPointsRecordArr}>
        <Table.Column title="建立時間" dataIndex="createdTime" width={50} />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column title="住戶點數" dataIndex="householdPoints" width={50} />
        <Table.Column title="更新時間" dataIndex="updatedTime" width={50} />
      </Table> */}
    </>
  );
};

export default PerMonthPoints;
